// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { StaySummaryComponent } from './stay-summary.component';
import { ReferencesModule } from '../../shared/components/references/references.module';
import { PriceWithConversionModule } from 'libraries/component/price-with-conversion/price-with-conversion.module';
import { DatesModule } from 'app_sasha/shared/services/dates/dates.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    declarations: [
        StaySummaryComponent,
    ],
    imports: [
        CommonModule,
        ReferencesModule,
        PriceWithConversionModule,
        DatesModule,
        FontAwesomeModule,
    ],
    exports: [
        StaySummaryComponent,
    ],
})
export class StaySummaryModule {}